import { log } from '@domgen/shared/utils/log';
import { StoreContext } from './store.types';

const STORAGE_KEY = 'app-session';

export type PersistedState = {
  context: {
    app: {
      session: StoreContext['app']['session'];
      catalogue: StoreContext['app']['catalogue'];
    };
    form: StoreContext['form'];
    urlParams?: StoreContext['urlParams'];
    applianceLookupResults?: StoreContext['applianceLookupResults'];
    quote?: StoreContext['quote'];
    confirmation?: StoreContext['confirmation'];
    gaEventData?: StoreContext['gaEventData'];
  };
  dateUpdated: number;
};

export const saveSession = (context: StoreContext) => {
  const { checkout, ...rest } = context;
  const { status, ...app } = rest.app;

  const payload: PersistedState = {
    context: {
      ...rest,
      app,
    },
    dateUpdated: Date.now(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    log.error({ message: 'Failed to save session', data: error });
  }
};

export const loadSession = (): PersistedState | undefined => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    return JSON.parse(raw);
  } catch (error) {
    log.error({ message: 'Failed to load session', data: error });
    return undefined;
  }
};

export const clearSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
